export default "__VITE_ASSET__8aed3696__"